@for (alert of alerts; track alert.id) {
  <div class="{{cssClass(alert)}}">
    <button mat-icon-button class="close" (click)="removeAlert(alert, 0)" aria-label="Close" i18n-aria-label>
      <mat-icon>close</mat-icon>
    </button>
    <span [innerHTML]="alert.message"></span>
  </div>
}
